import React from "react";
import styled from "styled-components";
import { SpaceProps, LayoutProps } from "styled-system";
import { ParagraphProps } from ".";
import { Box } from "../Box";
import { Text } from "../Text";
import { Title } from "../Title";

const StyledBox = styled(Box)`
  & > p > p:last-child {
    margin-bottom: 0px;
  }
`;

export const Paragraph: React.FC<ParagraphProps & SpaceProps & LayoutProps> = ({ title, content, ...rest }) => {
  return (
    <StyledBox data-testid="Paragraph" {...rest}>
      <Title as="h5" my={0}>
        {title}
      </Title>
      <Text my={0} dangerouslySetInnerHTML={{ __html: content }} />
    </StyledBox>
  );
};
